module.exports = __webpack_public_path__ + "files/e811cb9def339bfa26212438460c19c6.png";